import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrashAlt, faLock, faLockOpen, faPlus, faFileCsv } from "@fortawesome/free-solid-svg-icons";
import { useHistory } from 'react-router';
import './Listagem.scss';
import Busca from './Busca';
import { faFileExcel } from '@fortawesome/free-regular-svg-icons';

const Listagem = props => {

    const history = useHistory();

    const [page, setPage] = useState(0);
    const [paramsSearch, setParamsSearch] = useState([]);
    const total = props.registros.total;

    const setAcao = (acao, id) => {
        let rota = `/painel/${props.rota}/${acao}`;
        if (id) {
            rota += `/${id}`;
        }
        history.push(rota);
    };

    const mudarStatus = async (obj) => {
        const body = { active: !obj.active };
        await props.service.upsert(body, obj._id);
        props.service.getList(paramsSearch, page);
    }

    const deletar = async (obj) => {
        if (window.confirm("Deseja mesmo deletar o registro?")) {
            const body = { deleted: true }
            await props.service.upsert(body, obj._id);
            props.service.getList(paramsSearch, page);
        }
    }

    const handleDragStart = e => {
        e.currentTarget.classList.add('moving');
        const indice = getIndexTRFromTarget(e.currentTarget);
        e.dataTransfer.setData("from", indice);
    }

    const getIndexTRFromTarget = (target) => {
        const id = target.id;
        const trs = document.querySelectorAll('.gridView table tbody tr');
        for (let i = 0; i < trs.length; i++) {
            if (trs[i].id === id) {
                return i;
            }
        }
    }

    const handleDrop = e => {
        if (e.preventDefault) {
            e.preventDefault();
        }
        const to = getIndexTRFromTarget(e.currentTarget);
        const from = e.dataTransfer.getData("from");
        const eleFrom = document.querySelectorAll('.gridView table tbody tr')[from];
        const eleTo = document.querySelectorAll('.gridView table tbody tr')[to];
        if (from < to) {
            document.querySelector('.gridView table tbody').insertBefore(eleFrom, eleTo.nextSibling);
        } else {
            document.querySelector('.gridView table tbody').insertBefore(eleFrom, eleTo);
        }
        const trs = document.querySelectorAll('.gridView table tbody tr');
        const body = [];
        for (let i = 0; i < trs.length; i++) {
            const item = trs[i];
            const ordem = (1 + i);
            const _id = item.id;
            body.push({ _id, ordem });
        }
        props.service.reorder(body);
    }

    const handleDragEnd = e => {
        e.currentTarget.classList.remove('moving');
        const tableItems = document.querySelectorAll('.gridView table tbody tr');
        for (let item of tableItems) {
            item.classList.remove('over');
        }
    }

    const handleDragOver = e => {
        if (e.preventDefault) {
            e.preventDefault();
        }
        return false;
    }

    const handleDragEnter = e => {
        e.currentTarget.classList.add('over');
    }

    const handleDragLeave = e => {
        e.currentTarget.classList.remove('over');
    }

    const renderItems = () => {
        if (props.loadingList) {
            return (
                <tr>
                    <td colSpan={props.config.columns.length + 2}>Carregando listagem...</td>
                </tr>
            );
        }
        if (props.registros.rows.length > 0) {
            return props.registros.rows.map((ele, index) => {
                return (
                    <tr key={index} id={ele._id} draggable={props.config.sort ===  'ordem'}
                        onDragStart={handleDragStart}
                        onDragEnd={handleDragEnd}
                        onDragEnter={handleDragEnter}
                        onDragOver={handleDragOver}
                        onDragLeave={handleDragLeave}
                        onDrop={handleDrop}
                    >
                        {/* { props.config.sort === 'ordem' && <td>{ele.ordem}</td> } */}
                        {renderColumnsItems(ele)}
                        <td>{ele.active === true ? "Ativo" : "Inativo"}</td>
                        <td className="acoes">
                            <button className="edit" onClick={() => { setAcao('form', ele._id) }}><FontAwesomeIcon icon={faEdit} /></button>
                            <button className="status" onClick={() => { mudarStatus(ele) }}><FontAwesomeIcon icon={ele.active === true ? faLock : faLockOpen} /></button>
                            <button className="delete" onClick={() => { deletar(ele) }}><FontAwesomeIcon icon={faTrashAlt} /></button>
                        </td>
                    </tr>
                )
            })
        } else {
            return (
                <tr>
                    <td colSpan={props.config.columns.length + 2}>Nenhum registro encontrado</td>
                </tr>
            )
        }
    };

    const renderTitles = () => {
        const thead = (
            <tr>
                {/* { props.config.sort === 'ordem' && <td>#</td> } */}
                {renderColumns()}
                <td>Situação</td>
                <td width="150">Ações</td>
            </tr>
        );
        return thead;
    }

    const renderColumns = () => {
        return props.config.columns.map((c, i) => {
            return (
                <td key={i}>{c.label}</td>
            );
        });
    }

    const converts = {
        toImg: s => {
            return <img src={s} className="imgCrud" alt="imagem" />
        },
        toSimNao: s => {
            return s ? "Sim" : "Não";
        }
    }

    const renderColumnsItems = (row) => {
        return props.config.columns.map((c, i) => {
            const cls = c.field === "ordem" ? 'order' : '';
            return (
                <React.Fragment key={i}>
                    <td className={cls} width={c.width || ""}>
                        {renderValue(row,c)}
                        {/* {c.convert && typeof c.convert === 'string' && converts[c.convert](row[c.field])}
                        {c.convert && typeof c.convert === 'function' && c.convert(row[c.field])}
                        {!c.convert && row[c.field]} */}
                    </td>
                </React.Fragment>
            );
        });
    }

    const renderValue = (row, c) => {
        let value = row[c.field];

        if(c.field.includes('.')) {
            value = eval(`row.${c.field}`);
        }

        if(c.filter){
            const filtrado = row[c.filter.field].find(e=>e[c.filter.condition.field]===c.filter.condition.value);
            if(filtrado){
                value = filtrado[c.field];
            }
        }

        if(c.convert){
            if(typeof c.convert === 'string'){
                return converts[c.convert](value);
            }else if(typeof c.convert === 'function'){
                return c.convert(value);
            }
        }
        
        return value;
    }

    const buscar = params => {
        props.service.getList(params, 0);
        setParamsSearch(params);
        setPage(0);
    }

    const getList = _ => {
        props.service.getList([], 0);
        setPage(0);
    }

    const proximo = () => {
        const skip = page + props.config.pagination.limit;
        if (skip < total) {
            props.service.getList(paramsSearch, skip);
            setPage(skip)
        }
    }

    const temProximo = () => {
        const skip = page + props.config.pagination.limit;
        return skip < total;
    }
    const temAnterior = () => {
        const skip = page - props.config.pagination.limit;
        return skip >= 0;
    }

    const anterior = () => {
        const skip = page - props.config.pagination.limit;
        if (skip >= 0) {
            props.service.getList(paramsSearch, skip);
            setPage(skip)
        }
    }

    const getNumeroUltimoItem = () => {
        let n = ((page) + props.config.pagination.limit);
        if (n > total) {
            n = total;
        }
        return n;
    }

    const renderExtraButtons = () => {
        return <div className="extraButtons">
            {props.config.extraButtons.map((item, index)=>{
                return <button key={index} 
                    onClick={() => { item.action ? item.action() : console.log('Sem ação') }} 
                    className={[item.color ?? ""]}>
                        <FontAwesomeIcon style={{fontSize:20, marginRight:5}} icon={item.icon ?? faFileExcel} /> {item.label}
                    </button>
            })}
        </div>
    }

    return (
        <>
            <div className="crudView">
                <div className="searchBox">
                    <Busca config={props.config} service={{ buscar, getList }} />
                    <button onClick={() => { setAcao('form') }} className="novo"><FontAwesomeIcon icon={faPlus} /> Novo Registro</button>
                </div>
                {props.config.extraButtons && renderExtraButtons()}
                <div className="gridView">
                    <div className="pagination">
                        <span>{page + 1}-{getNumeroUltimoItem()} de {props.registros.total}</span>
                        <div className="links">
                            <span onClick={() => anterior()} className={!temAnterior() ? "disable" : ""}>anterior</span>
                            <span onClick={() => proximo()} className={!temProximo() ? "disable" : ""}>próximo</span>
                        </div>
                    </div>
                    <table cellPadding="0" cellSpacing="0">
                        <thead>
                            {renderTitles()}
                        </thead>
                        <tbody>
                            {renderItems()}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
}

export default Listagem;